export default __webpack_public_path__ + "static/media/sprecher_off.a997a212.svg";